const handleLogout = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("wp_session_key");
  document.cookie = "token" + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  window.history.pushState({ path: `${loginStatusButtonProps.signOutUrl}` }, "", `${loginStatusButtonProps.signOutUrl}`);
  window.location.reload()
}

export default handleLogout;